module.exports = __webpack_public_path__ + "img/startResumeSession.7628f518.png";